import { IonSpinner } from '@ionic/react';
import classNames from 'classnames';
import { User } from 'model';
import { useSendResetPasswordEmailMutation } from '../../api/UserApi';
// eslint-disable-next-line css-modules/no-unused-class
import settingsMenuStyles from '../SettingsMenu.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
import { IconAlert, IconCheck, IconRepeat } from '../QuirkIcons';
interface SendPasswordResetProps {
	user: User;
}

export const SendPasswordReset: React.FC<SendPasswordResetProps> = ({ user }) => {
	const [
		sendResetPasswordEmail,
		{ isError: sendResetError, isSuccess: sendResetSuccess, isLoading: sendingResetEmail }
	] = useSendResetPasswordEmailMutation();

	const sendPasswordResetEmail = () => {
		if (!sendResetSuccess && !sendResetError && !sendingResetEmail) {
			if (user) {
				sendResetPasswordEmail({ email: user.email });
			}
		}
	};
	const getPasswordResetMessage = () => {
		if (sendResetSuccess) {
			return (
				<>
					<div className="successColor">
						<IconCheck />
					</div>
					<div className={classNames(settingsMenuStyles.menuItemLabel, 'successColor')}>
						Password reset sent
					</div>
				</>
			);
		} else if (sendResetError) {
			return (
				<>
					<div className="dangerColor">
						<IconAlert />
					</div>
					<div className="dangerColor">Error sending email</div>
				</>
			);
		} else if (sendingResetEmail) {
			return (
				<>
					<IonSpinner className={sharedStyles.controlIcon} />
					<div className={settingsMenuStyles.menuItemLabel}>Sending password reset email...</div>
				</>
			);
		} else {
			return (
				<>
					<IconRepeat />
					<div className={settingsMenuStyles.menuItemLabel}>Send password reset email</div>
				</>
			);
		}
	};

	return (
		<div className={settingsMenuStyles.menuItemContainer} onClick={sendPasswordResetEmail}>
			{getPasswordResetMessage()}
		</div>
	);
};
